(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kdk-men-dynamic"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function init(root){
    if(!root || root.dataset.kdkMenReady) return;
    root.dataset.kdkMenReady='true';
    document.body.classList.add('kdk-men-page');
    var menCategoryQuery=new URLSearchParams(window.location.search);
    var menCategoryActive=menCategoryQuery.get('filter.p.t.category')||'all';
    var menPreview=menCategoryQuery.get('preview_theme_id');
    root.querySelectorAll('[data-kdk-men-category]').forEach(function(link){
      var ids=link.getAttribute('data-kdk-category-ids');
      if(ids===menCategoryActive){link.classList.add('is-active');link.setAttribute('aria-current','page');}
      if(menPreview){
        var dest=new URL(link.getAttribute('href'),window.location.origin);
        dest.searchParams.set('preview_theme_id',menPreview);
        link.setAttribute('href',dest.pathname+dest.search+dest.hash);
      }
    });

    var slides=Array.prototype.slice.call(root.querySelectorAll('[data-kdk-men-slide]'));
    var cards=Array.prototype.slice.call(root.querySelectorAll('[data-kdk-men-look]'));
    var rail=root.querySelector('[data-kdk-men-rail]');
    var range=root.querySelector('[data-kdk-men-range]');
    if(!slides.length) return;
    var selected=0,inView=false,lastUser=0,lastScroll=window.scrollY,lastChange=0;
    var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var delay=Math.max(5000,Math.min(12000,(Number(root.dataset.rotate)||7)*1000));
    function select(i,scrollCard){
      selected=(i+slides.length)%slides.length;
      slides.forEach(function(s,j){s.hidden=j!==selected;s.classList.toggle('is-current',j===selected);});
      cards.forEach(function(c,j){
        c.classList.toggle('is-selected',j===selected);
        var b=c.querySelector('[data-kdk-men-pick]');
        if(b)b.setAttribute('aria-pressed',j===selected?'true':'false');
      });
      if(scrollCard&&rail&&cards[selected])rail.scrollTo({left:cards[selected].offsetLeft-rail.offsetLeft,behavior:reduce?'auto':'smooth'});
    }
    function sync(){
      if(!rail||!range)return;
      var max=Math.max(0,rail.scrollWidth-rail.clientWidth);
      range.parentElement.hidden=max<3;
      range.value=max?String(Math.round(100*rail.scrollLeft/max)):'0';
    }
    cards.forEach(function(c,i){c.addEventListener('click',function(e){if(e.target.closest('a'))return;lastUser=Date.now();select(i,false);});});
    if(rail&&range){
      range.addEventListener('input',function(){lastUser=Date.now();rail.scrollLeft=Math.max(0,rail.scrollWidth-rail.clientWidth)*Number(range.value)/100;});
      rail.addEventListener('scroll',sync,{passive:true});
      rail.addEventListener('pointerdown',function(){lastUser=Date.now();},{passive:true});
      window.addEventListener('resize',sync,{passive:true});
      sync();
    }
    if(!reduce&&slides.length>1){
      if('IntersectionObserver' in window){
        var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.target===root)inView=e.isIntersecting;});},{threshold:.08});
        obs.observe(root);
      }else{inView=true;}
      window.addEventListener('scroll',function(){
        if(!inView||document.hidden||Date.now()-lastUser<5000)return;
        var y=window.scrollY;
        if(Math.abs(y-lastScroll)<180)return;
        lastScroll=y;
        if(Date.now()-lastChange<1800)return;
        lastChange=Date.now();
        select(selected+1,false);
      },{passive:true});
      window.setInterval(function(){
        if(!inView||document.hidden||Date.now()-lastUser<6500)return;
        select(selected+1,true);
      },delay);
    }
    select(0,false);
  }
  function ready(){document.querySelectorAll('[data-kdk-men]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
  document.addEventListener('shopify:section:load',ready);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kdk-pairing-all"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__kdkUniversalPairingV1)return;
  window.__kdkUniversalPairingV1=true;
  function shopRoot(){return window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';}
  function currentVariant(root){
    var parent=document.querySelector('.main-product-section[data-product-wrapper]')||document.querySelector('[data-product-wrapper]');
    var controls=parent?parent.querySelectorAll('form input[name="id"],form select[name="id"]'):[];
    for(var i=0;i<controls.length;i++){if(controls[i].value&&!controls[i].disabled){var id=Number(controls[i].value);if(id>0)return id;}}
    return Number(root.dataset.kdkFirstVariant)||0;
  }
  async function fetchCart(){
    var response=await fetch(shopRoot()+'cart.js',{credentials:'same-origin',cache:'no-store'});
    if(!response.ok)throw new Error('Sepet bilgisi alınamadı.');
    return response.json();
  }
  async function hydrate(root){
    if(!root||Number(root.dataset.kdkPairCount)>0||root.dataset.kdkLookup==='done')return;
    root.dataset.kdkLookup='done';
    try{
      var response=await fetch(root.dataset.kdkPairRecommendations,{credentials:'same-origin'});
      if(!response.ok)return;
      var html=await response.text();
      var doc=new DOMParser().parseFromString(html,'text/html');
      var fresh=doc.querySelector('[data-kdk-pair-root]');
      if(!fresh||!(Number(fresh.dataset.kdkPairCount)>0))return;
      var newCards=fresh.querySelector('[data-kdk-pair-cards]');
      var cards=root.querySelector('[data-kdk-pair-cards]');
      if(newCards&&cards){cards.innerHTML=newCards.innerHTML;root.dataset.kdkPairCount=fresh.dataset.kdkPairCount;}
      var empty=root.querySelector('[data-kdk-pair-empty]');
      if(empty)empty.hidden=true;
    }catch(e){}
  }
  function init(){
    document.querySelectorAll('[data-kdk-pair-root]').forEach(function(root){hydrate(root);});
  }
  document.addEventListener('click',async function(event){
    var button=event.target.closest('[data-kdk-pair-add]');
    if(!button||button.disabled)return;
    var card=button.closest('[data-kdk-pair-card]');
    var root=button.closest('[data-kdk-pair-root]');
    if(!card||!root)return;
    var select=card.querySelector('[data-kdk-pair-variant]');
    var extra=Number(select&&select.value)||0;
    var main=currentVariant(root);
    var status=card.querySelector('[data-kdk-pair-status]');
    if(!extra||!main||extra===main){
      if(status){status.textContent='Lütfen ürünlerin beden / seçeneklerini kontrol et.';status.setAttribute('data-error','');}
      return;
    }
    button.disabled=true;
    if(status){status.removeAttribute('data-error');status.textContent='Kombinin sepete ekleniyor...';}
    try{
      var before=await fetchCart();
      var existing=before.items.some(function(item){return Number(item.variant_id)===main&&Number(item.quantity)>0;});
      var entries=existing?[{id:extra,quantity:1}]:[{id:main,quantity:1},{id:extra,quantity:1}];
      var response=await fetch(shopRoot()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:entries})});
      var result=await response.json().catch(function(){return {};});
      if(!response.ok)throw new Error(result.description||result.message||'Ürün sepete eklenemedi.');
      var cart=await fetchCart();
      var actual=Number(cart.total_discount)||0;
      if(status){
        if(actual>0){status.textContent='Kombinin sepette. Uygulanan tasarrufu sepetinde görebilirsin.';}
        else{status.textContent='Kombinin sepete eklendi. Uygun indirim tutarını sepette kontrol et.';}
      }
      document.dispatchEvent(new CustomEvent('cart:updated',{detail:{source:'kdk-pairing'}}));
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{source:'kdk-pairing'}}));
      window.location.assign(shopRoot()+'cart');
    }catch(err){
      if(status){status.textContent=err.message||'Sepete ekleme başarısız oldu.';status.setAttribute('data-error','');}
      button.disabled=false;
    }
  });
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init,{once:true});}else{init();}
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kdk-watch-matches"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',async function(event){
  const navButton=event.target.closest('[data-kdk-watch-prev],[data-kdk-watch-next]');
  if(navButton){
    const section=navButton.closest('[data-kdk-watch-trio-section]');
    const rail=section&&section.querySelector('[data-kdk-watch-rail]');
    if(rail)rail.scrollBy({left:rail.clientWidth*(navButton.hasAttribute('data-kdk-watch-next')?0.88:-0.88),behavior:'smooth'});
    return;
  }
  const button=event.target.closest('[data-kdk-watch-trio-add]');
  if(!button || button.disabled)return;
  const card=button.closest('.kdk-watch-trio');
  const status=card&&card.querySelector('.kdk-watch-trio__status');
  const ids=[button.dataset.watchVariant,button.dataset.walletVariant,button.dataset.bagVariant].map(Number);
  if(ids.some(v=>!Number.isSafeInteger(v)||v<=0)||new Set(ids).size!==3)return;
  const original=button.innerHTML;
  button.disabled=true;
  button.textContent=button.dataset.loadingLabel||'';
  if(status){status.hidden=true;status.textContent='';}
  try{
    const prefix=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    const response=await fetch(prefix+'cart/add.js',{
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:ids.map(id=>({id,quantity:1}))})
    });
    if(!response.ok)throw new Error('cart_add_failed');
    window.location.assign(prefix+'cart');
  }catch(error){
    if(status){status.textContent=button.dataset.errorLabel||'';status.hidden=false;}
    button.innerHTML=original;
    button.disabled=false;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      const applyAccordionState = () => {
        const showAccordionOnMobile =
          document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        document.querySelectorAll('details[data-accordion]').forEach((el) => {
          if (showAccordionOnMobile && isMobile) {
            // Show accordion on mobile if setting allows
            el.removeAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','false');
          } else if (!showAccordionOnMobile && isMobile) {
            // Do not show accordion on mobile if setting disallows
           // el.setAttribute('open');
          } else if (!isMobile) {
            // On desktop, always open accordions
            el.setAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','true');
          }
        });
      };
      applyAccordionState();
      window.addEventListener('resize', applyAccordionState);
      document.addEventListener('shopify:section:load', (event) => {
        // Apply accordion state when a new section is loaded
        applyAccordionState();
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
